import React, { lazy, Suspense } from "react";
import Backdrop from "components/common-components/backdrop";

const Default = lazy(() => import("../../../../../layouts/dashboard/default"));
const AllZone = lazy(() => import("../pages/all-zone"));

export const ZoneRouter = [
  {
    path: "/master-management/zone",
    element: (
      <Suspense fallback={<Backdrop />}>
        <Default />
      </Suspense>
    ),
    children: [
      {
        path: "all",
        element: (
          <Suspense fallback={<Backdrop />}>
            <AllZone />
          </Suspense>
        ),
      },
    ],
  },
];
